import { render, staticRenderFns } from "./CustomerDecision.vue?vue&type=template&id=88fa4026&scoped=true"
import script from "./CustomerDecision.vue?vue&type=script&lang=js"
export * from "./CustomerDecision.vue?vue&type=script&lang=js"
import style0 from "./CustomerDecision.vue?vue&type=style&index=0&id=88fa4026&prod&scoped=true&lang=css"
import style1 from "./CustomerDecision.vue?vue&type=style&index=1&id=88fa4026&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fa4026",
  null
  
)

export default component.exports